import { useTranslation } from 'react-i18next';

import type { VerificationStep } from '../types';

import styles from './VerificationProgressIndicator.module.scss';

interface VerificationProgressIndicatorProps {
  steps: VerificationStep[];
  currentStepIndex: number;
  completionPercentage: number;
}

const VerificationProgressIndicator = ({ 
  steps, 
  currentStepIndex, 
  completionPercentage 
}: VerificationProgressIndicatorProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>{t('mfa.security_setup_progress')}</h3>
        <div className={styles.percentage}>{Math.round(completionPercentage)}%</div>
      </div>

      <div className={styles.stepsList}>
        {steps.map((step, index) => (
          <div 
            key={step.id}
            className={`${styles.stepItem} ${step.status === 'completed' ? styles.completed : ''} ${
              step.status === 'in-progress' ? styles.inProgress : ''
            }`}
          >
            <div className={styles.stepIcon}>
              {step.status === 'completed' ? '✅' : step.icon}
            </div>
            
            <div className={styles.stepContent}>
              <div className={styles.stepTitle}>{step.title}</div>
              <div className={styles.stepDescription}>{step.description}</div>
            </div>

            <div className={`${styles.stepStatus} ${
              step.status === 'completed' ? styles.completed : 
              step.status === 'in-progress' ? styles.inProgress : ''
            }`}>
              {step.status === 'completed' ? 'Completed' : 
               step.status === 'in-progress' ? 'In Progress' : 'Pending'}
            </div>
          </div>
        ))}
      </div>

      <div className={styles.completionText}>
        {completionPercentage === 100 ? (
          <span>🎉 All steps completed!</span>
        ) : (
          <span>
            {steps.filter(s => s.status !== 'completed').length} steps remaining
          </span>
        )}
      </div>
    </div>
  );
};

export default VerificationProgressIndicator;